import { useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

import { useProfileData } from "../../../../hooks/useProfileData";

import { useGetChatList } from "../../hooks/useGetChatList";

import ChatSideBar from "./ChatSideBar";
import ChatContainer from "./ChatContainer"; // Mobile responsive chat container

const ChatPage = () => {
  const [searchValue, setSearchValue] = useState("");
  const [showSidebar, setShowSidebar] = useState(true);
  const handleOnSearch = (value: string) => setSearchValue(value);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const {
    data: { id: ownUserId },
    isLoading: isUserDataLoading,
  } = useProfileData();

  const { chats, isLoading: isChatsListLoading } = useGetChatList(ownUserId, searchValue);

  const isChatLoading = isUserDataLoading || isChatsListLoading;

  // On mobile, hide sidebar by default when a chat is selected
  const handleChatSelect = () => {
    if (isMobile) {
      setShowSidebar(false);
    }
  };

  const handleBackToSidebar = () => {
    setShowSidebar(true);
  };

  return (
    <Box sx={styles.container}>
      {(showSidebar || !isMobile) && (
        <ChatSideBar
          searchValue={searchValue}
          handleOnSearch={handleOnSearch}
          chats={chats}
          isChatLoading={isChatLoading}
          ownUserId={ownUserId!}
          onChatSelect={handleChatSelect}
          isMobile={isMobile}
        />
      )}
      <ChatContainer
        isLoading={isChatLoading}
        onBackToSidebar={handleBackToSidebar}
        isMobile={isMobile}
        showBackButton={isMobile && !showSidebar}
      />
    </Box>
  );
};

export default ChatPage;

const styles = {
  container: {
    height: {
      xs: "100vh", // Full viewport height on mobile
      md: "fit-content", // Fit content on desktop
    },
    minHeight: {
      xs: "100vh", // Full viewport height on mobile
      md: "958px", // Original min height on desktop
    },
    borderRadius: {
      xs: "0", // No border radius on mobile for full screen
      md: "8px", // Rounded corners on desktop
    },
    border: {
      xs: "none", // No border on mobile
      md: "1px solid #EAECF0", // Border on desktop
    },
    background: "#FFF",
    display: "flex",
    flexDirection: {
      xs: "column", // Stack vertically on mobile
      md: "row", // Side by side on desktop
    },
    overflow: "hidden",
    width: "100%",
    maxWidth: "100vw",
    // Add shadow on mobile for better separation
    boxShadow: {
      xs: "0 -2px 8px rgba(0, 0, 0, 0.1)", // Shadow on mobile
      md: "none", // No shadow on desktop
    },
    // Add smooth transition for mobile layout changes
    transition: {
      xs: "all 0.3s ease-in-out", // Smooth transition on mobile
      md: "none", // No transition on desktop
    },
  },
};
